<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('stockTransfer.transferBySerial') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockTransfer.transferBySerial'),
            href: '/transfer-by-serials'
          },
          {
            text: $t('stockTransfer.create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="ready_fetch">
          <form class="form-horizontal">
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.date') }}
                  </label>
                  <div class="col-md-7">
                    <ts-date-picker-input
                      v-model="model.transfer_date"
                      :closeOnSelect="true"
                    ></ts-date-picker-input>
                    <div class="validate" v-if="errors.has('transfer_date')">
                      {{ errors.first('transfer_date') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label"> </label>
                  <div class="col-md-7">
                    <ts-checkbox
                      v-model="chk_current_branch"
                      @change="setCurrentBranch"
                    >
                      {{ $t('stockTransfer.to_current_branch') }}
                    </ts-checkbox>
                  </div>
                </div>
                <div class="form-group row" v-if="chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.from_location') }}
                    <i
                      class="fas fa-spinner spin"
                      v-if="fetchFromWarehouse"
                    ></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.from_location_id"
                      :disabled="fetchFromWarehouse"
                      :class="{ 'is-invalid': errors.has('from_location_id') }"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(warehouse, index) in fromWarehouses"
                        :key="index"
                        :value="warehouse.location_id"
                      >
                        {{ warehouse.location_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('from_location_id')"
                    >
                      {{ errors.first('from_location_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_location') }}
                    <i class="fas fa-spinner spin" v-if="fetchToWarehouse"></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_location_id"
                      :disabled="fetchToWarehouse"
                      :class="{ 'is-invalid': errors.has('to_location_id') }"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(warehouse, index) in toWarehouses"
                        :key="index"
                        :value="warehouse.location_id"
                      >
                        {{ warehouse.location_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_location_id')"
                    >
                      {{ errors.first('to_location_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="!chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_branch') }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_branch_id"
                      :class="{ 'is-invalid': errors.has('to_branch_id') }"
                      @change="onChangeBranch"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(branch, index) in branches"
                        :key="index"
                        :value="branch.branch_id"
                      >
                        {{ branch.branch_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_branch_id')"
                    >
                      {{ errors.first('to_branch_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="!chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_location') }}
                    <i class="fas fa-spinner spin" v-if="fetchToWarehouse"></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_location_id"
                      :disabled="fetchToWarehouse"
                      :class="{
                        'is-invalid': errors.has('to_location_id')
                      }"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(warehouse, index) in toWarehouses"
                        :key="index"
                        :value="warehouse.location_id"
                      >
                        {{ warehouse.location_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_location_id')"
                    >
                      {{ errors.first('to_location_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.transferStatus') }}
                  </label>
                  <div class="col-md-7">
                    <div class="alert alert-secondary fade show">
                      <a-radio-group v-model="model.sn_status_id">
                        <a-radio
                          v-for="(status, index) in serialStatus"
                          :key="index"
                          :style="radioStyle"
                          :value="status.sn_status_id"
                        >
                          {{ status.sn_status }}
                        </a-radio>
                      </a-radio-group>
                    </div>
                    <div class="validate" v-if="errors.has('sn_status_id')">
                      {{ errors.first('sn_status_id') }}
                    </div>
                    <span class="validate" v-if="snStatusIdErrors.length > 0">{{
                      snStatusIdErrors[0]
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <a-tabs
                  :default-active-key="1"
                  @change="callback"
                  class="ts-mb-3"
                  v-show="!allow_only_scan_on_transfer"
                >
                  <a-tab-pane :key="1" :tab="$t('stockTransfer.byRange')">
                    <form class="form-horizontal">
                      <div class="row" v-if="activeTab == 1">
                        <div class="col-lg-5">
                          <div class="form-group row">
                            <label
                              class="col-md-4 form-col-label control-label"
                            >
                              {{ $t('stockTransfer.category') }}
                            </label>
                            <div class="col-md-7">
                              <a-select
                                v-model="category_id"
                                showSearch
                                mode="multiple"
                                class="ts-w-full"
                                optionFilterProp="children"
                                :maxTagTextLength="17"
                                :maxTagCount="1"
                                :placeholder="$t('all')"
                                :options="
                                  categoryAvailables.map(el => ({
                                    value: el.category_id,
                                    label: el.category
                                  }))
                                "
                                :filterOption="
                                  (input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-5">
                          <div class="form-group row">
                            <label
                              class="col-md-4 form-col-label control-label"
                            >
                              {{ $t('stockTransfer.availableProduct') }}
                            </label>
                            <div class="col-md-7">
                              <a-select
                                v-model="product_available_id"
                                showSearch
                                mode="multiple"
                                class="ts-w-full"
                                optionFilterProp="children"
                                :maxTagTextLength="17"
                                :maxTagCount="1"
                                :placeholder="$t('all')"
                                :options="
                                  productAvailables.map(el => ({
                                    value: el.product_id,
                                    label:
                                      el.barcode +
                                      '|' +
                                      el.product_group +
                                      '|' +
                                      el.product_name
                                  }))
                                "
                                :filterOption="
                                  (input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <ts-button
                            outline
                            color="primary"
                            :waiting="fetchingProduct"
                            @click.prevent="fetchProductAvailable"
                          >
                            {{ $t('search') }}
                          </ts-button>
                        </div>
                      </div>
                    </form>
                  </a-tab-pane>
                  <a-tab-pane :key="2" :tab="$t('stockTransfer.byScan')">
                    <SearchBox
                      v-if="activeTab == 2"
                      v-model="fetchOptions"
                      :waiting="fetchingProduct"
                      @onEnter="fetchProduct"
                    />
                  </a-tab-pane>
                </a-tabs>
                <SearchBox
                  :disabled="allow_only_scan_on_transfer"
                  v-if="allow_only_scan_on_transfer"
                  v-model="fetchOptions"
                  :waiting="fetchingProduct"
                  @onEnter="fetchProduct"
                />
                <b-alert
                  ref="success"
                  variant="success"
                  :show="success_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li
                      v-for="(message, index) in success_message"
                      :key="index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <b-alert
                  ref="info"
                  variant="info"
                  :show="info_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li v-for="(message, index) in info_message" :key="index">
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <b-alert
                  ref="danger"
                  variant="danger"
                  :show="error_message.length > 0"
                  dismissible
                >
                  <ul class="ts-list-disc">
                    <li v-for="(message, index) in error_message" :key="index">
                      {{ message }}
                    </li>
                  </ul>
                </b-alert>
                <div
                  class="ts-h-64 ts-mt-3 ts-rounded ts-overflow-y-scroll"
                  v-if="activeTab == 1"
                >
                  <ts-loading-banner :loading="fetchingProduct">
                    <div class="container-product">
                      <table class="ts-w-full product-table" id="product-table">
                        <thead>
                          <tr>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                              style="width: 14%"
                            >
                              {{ $t('stockTransfer.barcode') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3"
                            >
                              {{ $t('stockTransfer.product') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('stockTransfer.uom') }}
                            </th>
                            <!-- <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-right"
                              style="width: 7%"
                            >
                              {{ $t('stockTransfer.cost') }}
                            </th> -->
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 6%"
                            >
                              {{ $t('stockTransfer.availableQuantity') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 6%"
                            >
                              {{ $t('stockTransfer.serialQuantity') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 10%"
                            >
                              {{ $t('stockTransfer.minSerialNo') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 10%"
                            >
                              {{ $t('stockTransfer.maxSerialNo') }}
                            </th>
                            <!-- <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-right"
                              style="width: 10%"
                            >
                              {{ $t('stockTransfer.amount') }}
                            </th> -->
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                              style="width: 3%"
                            >
                              {{ $t('actions') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item,
                            index) in model.sub_item_list_by_serial_range"
                            :key="index"
                          >
                            <td class="ts-py-1 ts-px-3">
                              {{ getProdcutById(item.product_id).barcode }}
                            </td>
                            <td class="ts-py-1 ts-px-3">
                              {{
                                getProdcutById(item.product_id).product_name_en
                              }}
                            </td>
                            <td class="ts-py-1 ts-px-3 text-center">
                              {{ getUomNameById(item.uom_id) }}
                            </td>
                            <!-- <td
                              class="ts-py-1 ts-px-3 text-right"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ item.cost }}
                            </td> -->
                            <td class="ts-py-1 text-center">
                              <input
                                type="number"
                                disabled
                                v-model.number="item.available_quantity"
                                step="any"
                                class="form-control only-border-bottom"
                              />
                            </td>
                            <td class="ts-py-1 text-center">
                              <input
                                type="number"
                                @click="select(index)"
                                ref="transfer_quantity"
                                @keypress.enter="onSerialQtyEnter(index)"
                                @input="getSerialByQty(item, index)"
                                v-model.number="item.transfer_quantity"
                                :max="item.transfer_quantity"
                                step="any"
                                class="form-control only-border-bottom"
                                :class="{
                                  'is-invalid': errors.has(
                                    'sub_item_list_by_serial_range.' +
                                      index +
                                      '.transfer_quantity'
                                  )
                                }"
                              />
                              <div
                                class="validate"
                                v-if="
                                  errors.has(
                                    'sub_item_list_by_serial_range.' +
                                      index +
                                      '.transfer_quantity'
                                  )
                                "
                              >
                                {{
                                  errors.first(
                                    'sub_item_list_by_serial_range.' +
                                      index +
                                      '.transfer_quantity'
                                  )
                                }}
                              </div>
                            </td>
                            <td class="ts-py-1 text-center">
                              <input
                                v-show="item.min_serial_no"
                                ref="min_serial_no"
                                type="text"
                                disabled
                                v-model.number="item.min_serial_no"
                                step="any"
                                class="form-control only-border-bottom"
                              />
                            </td>
                            <td class="ts-py-1 text-center">
                              <input
                                v-show="item.max_serial_no"
                                ref="max_serial_no"
                                type="text"
                                disabled
                                v-model.number="item.max_serial_no"
                                step="any"
                                class="form-control only-border-bottom"
                              />
                            </td>
                            <!-- <td
                              class="ts-py-1 ts-px-3 text-right"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ totalAmount(item) }}
                            </td> -->
                            <td class="text-center">
                              <a-popconfirm
                                placement="leftTop"
                                :title="$t('are_you_sure_to_delete')"
                                :ok-text="$t('yes')"
                                :cancel-text="$t('no')"
                                @confirm="removeSerialRangeRow(item)"
                              >
                                <a href="#" v-tooltip="$t('delete')">
                                  <i class="fa fa-trash mr-2 text-red"></i>
                                </a>
                              </a-popconfirm>
                              <!-- <a
                                v-show="item.min_serial_no"
                                href="#"
                                v-tooltip="$t('stockTransfer.escapedSerial')"
                                class="text-warning"
                                @click.prevent="escapedSerial(item)"
                              >
                                <i class="fas fa-indent"></i>
                              </a> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <table
                      style="width: 100%"
                      class="mt-2"
                      id="amountValue"
                      v-if="model.sub_item_list.length"
                    >
                      <tr>
                        <td style="width: 90%" class="text-right">
                          <label class="col-form-label text-red">
                            {{ $t('stockTransfer.grand_total') }} :
                          </label>
                        </td>
                        <td class="pl-2">
                          <input
                            disabled
                            type="number"
                            v-model.number="model.total_amount"
                            class="form-control text-danger ts-font-bold"
                          />
                        </td>
                      </tr>
                    </table> -->
                  </ts-loading-banner>
                </div>
                <div
                  class="ts-h-64 ts-mt-3 ts-rounded ts-overflow-y-scroll"
                  v-if="activeTab == 2"
                >
                  <ts-loading-banner :loading="fetchingProduct">
                    <div class="container-product">
                      <table class="ts-w-full product-table" id="product-table">
                        <thead>
                          <tr>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                              style="width: 14%"
                            >
                              {{ $t('stockTransfer.barcode') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3"
                            >
                              {{ $t('stockTransfer.product') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('stockTransfer.uom') }}
                            </th>
                            <!-- <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-right"
                              style="width: 7%"
                            >
                              {{ $t('stockTransfer.cost') }}
                            </th> -->
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('stockTransfer.availableQuantity') }}
                            </th>
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                              style="width: 9%"
                            >
                              {{ $t('stockTransfer.qty') }}
                            </th>
                            <!-- <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-right"
                              style="width: 10%"
                            >
                              {{ $t('stockTransfer.amount') }}
                            </th> -->
                            <th
                              class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                              style="width: 3%"
                            >
                              <a
                                class="text-primary"
                                @click.prevent="manualAdd"
                                v-tooltip="$t('stockTransfer.addProduct')"
                              >
                                <i
                                  class="fas fa-spinner spin"
                                  v-if="ready_fetch"
                                ></i>
                                <i class="fa fa-plus" v-else></i>
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in model.sub_item_list"
                            :key="index"
                          >
                            <td
                              class="ts-py-1 ts-px-3"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ getProdcutById(item.product_id).barcode }}
                            </td>
                            <td
                              class="ts-py-1 ts-px-3"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{
                                getProdcutById(item.product_id).product_name_en
                              }}
                            </td>
                            <td
                              class="ts-py-1 ts-px-3 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ getUomNameById(item.uom_id) }}
                            </td>
                            <!-- <td
                              class="ts-py-1 ts-px-3 text-right"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ item.cost }}
                            </td> -->
                            <td
                              class="ts-py-1 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              <input
                                type="number"
                                disabled
                                v-model.number="item.available_quantity"
                                step="any"
                                class="form-control only-border-bottom"
                              />
                            </td>
                            <td
                              class="ts-py-1 text-center"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              <input
                                v-if="item.serial_no.length > 0"
                                :disabled="item.serial_no.length > 0"
                                type="number"
                                v-model.number="item.quantity"
                                step="any"
                                class="form-control only-border-bottom"
                                :class="{
                                  'is-invalid': errors.has(
                                    'sub_item_list.' + index + '.quantity'
                                  )
                                }"
                              />
                              <input
                                v-else
                                :disabled="item.serial_no.length > 0"
                                type="number"
                                v-model.number="item.quantity"
                                step="any"
                                class="form-control only-border-bottom"
                                @keypress.enter="onCountQtyEnter(index)"
                                ref="quantity"
                                :class="{
                                  'is-invalid': errors.has(
                                    'sub_item_list.' + index + '.quantity'
                                  )
                                }"
                              />
                            </td>
                            <!-- <td
                              class="ts-py-1 ts-px-3 text-right"
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                            >
                              {{ totalAmount(item) }}
                            </td> -->
                            <td
                              :class="{
                                'selected-class': item.product_id == product_id
                              }"
                              class="text-center"
                            >
                              <a-popconfirm
                                placement="leftTop"
                                :title="$t('are_you_sure_to_delete')"
                                :ok-text="$t('yes')"
                                :cancel-text="$t('no')"
                                @confirm="removeRow(item)"
                              >
                                <a href="#" v-tooltip="$t('delete')">
                                  <i class="fa fa-trash mr-2 text-red"></i>
                                </a>
                              </a-popconfirm>
                              <a
                                v-show="item.serial_no.length > 0"
                                href="#"
                                v-tooltip="$t('stockTransfer.showSerial')"
                                class="text-info"
                                @click.prevent="show(item)"
                              >
                                <i class="fas fa-align-justify"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <table
                      style="width: 100%"
                      class="mt-2"
                      id="amountValue"
                      v-if="model.sub_item_list.length"
                    >
                      <tr>
                        <td style="width: 90%" class="text-right">
                          <label class="col-form-label text-red">
                            {{ $t('stockTransfer.grand_total') }} :
                          </label>
                        </td>
                        <td class="pl-2">
                          <input
                            disabled
                            type="number"
                            v-model.number="model.total_amount"
                            class="form-control text-danger ts-font-bold"
                          />
                        </td>
                      </tr>
                    </table> -->
                  </ts-loading-banner>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'transfer-by-serial' })"
              >
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                color="primary"
                outline
                @click.prevent="storePreview"
                :waiting="savePreviewing"
                v-if="
                  model.sub_item_list.length ||
                    model.sub_item_list_by_serial_range.length
                "
              >
                {{ $t('savePrint') }}
              </ts-button>
              <ts-button
                color="primary"
                @click.prevent="store"
                :waiting="saving"
                v-if="
                  model.sub_item_list.length ||
                    model.sub_item_list_by_serial_range.length
                "
              >
                {{ $t('save') }}
              </ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
      <a-modal
        :title="$t('stockTransfer.availableSerial')"
        width="45%"
        v-model="show_serial"
        :footer="null"
        @cancel="handleCancel"
      >
        <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
          <a-tabs :default-active-key="1" @change="callback1" class="ts-mb-3">
            <a-tab-pane :key="1" :tab="$t('stockTransfer.byRange')">
              <div class="ts-flex" v-if="activeTab1 == 1">
                <div class="ts-flex-1">
                  <input
                    v-model="from_serial"
                    type="text"
                    class="form-control"
                    :placeholder="$t('stockTransfer.fromSerial')"
                  />
                </div>
                <div class="ts-flex-1 ts-text-center">
                  <i class="fas fa-arrow-right fa-2x"></i>
                </div>
                <div class="ts-flex-1">
                  <input
                    v-model="to_serial"
                    type="text"
                    class="form-control"
                    :placeholder="$t('stockTransfer.toSerial')"
                  />
                </div>
                <div class="ts-flex-1 ts-text-right">
                  <ts-button outline color="primary" @click.prevent="submit">
                    {{ $t('stockTransfer.submit') }}
                  </ts-button>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="2" :tab="$t('stockTransfer.byScan')">
              <SearchBox v-model="searchSerial" v-if="activeTab1 == 2" />
            </a-tab-pane>
          </a-tabs>
          <div class="ts-mt-3 ts-h-64 ts-rounded ts-overflow-y-scroll">
            <div class="container-product">
              <table class="ts-w-full product-table" id="product-table">
                <thead>
                  <tr>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                      style="width: 14%"
                    >
                      {{ $t('stockTransfer.barcode') }}
                    </th>
                    <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                      {{ $t('stockTransfer.product') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 9%"
                    >
                      {{ $t('stockTransfer.uom') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 9%"
                    >
                      {{ $t('stockTransfer.serial') }}
                    </th>
                    <th
                      class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                      style="width: 1%"
                      v-if="activeTab1 == 2"
                    >
                      {{ $t('actions') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(serial, index) in serialResource" :key="index">
                    <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                      {{ getProdcutById(show_detial_item.product_id).barcode }}
                    </td>
                    <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                      {{
                        getProdcutById(show_detial_item.product_id)
                          .product_name_en
                      }}
                    </td>
                    <td
                      class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                    >
                      {{ getUomNameById(show_detial_item.uom_id) }}
                    </td>
                    <td
                      class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap"
                    >
                      {{ serial }}
                    </td>
                    <td class="text-center" v-if="activeTab1 == 2">
                      <a-popconfirm
                        placement="leftTop"
                        :title="$t('are_you_sure_to_delete')"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                        @confirm="removeSerial(serial)"
                      >
                        <a href="#">
                          <i class="fa fa-trash mr-2 text-red"></i>
                        </a>
                      </a-popconfirm>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="ts-mt-4 ts-text-right ts-font-bold" v-if="activeTab1 == 1">
          TOTAL : {{ serialResource.length }}
        </div>
        <div class="ts-mt-4 ts-text-right ts-font-bold" v-else>
          TOTAL : {{ !isEmpty ? show_detial_item.serial_no.length : 0 }}
        </div>
      </a-modal>
      <a-modal
        v-if="show_manual_add"
        v-model="show_manual_add"
        :title="$t('stockTransfer.recipeAddOnSparePart')"
        :footer="null"
        :centered="true"
        :zIndex="1020"
        :maskClosable="false"
        width="800px"
      >
        <Manual
          v-model="model"
          @close="() => ((show_manual_add = false), (product_id = ''))"
        />
      </a-modal>
      <a-modal
        :title="$t('stockTransfer.escapedSerial')"
        width="500px"
        v-model="show_escaped_serial"
        :footer="null"
        @cancel="handleCancel"
      >
        <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
          <SearchBoxSerial
            v-model="serialForEscap"
            :waiting="fetchEscap"
            @onEnter="fetchSerialForEscap"
          />
          <div class="ts-mt-3 ts-h-64 ts-rounded ts-overflow-y-scroll">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th
                    class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 "
                    style="width: 14%"
                  >
                    {{ $t('stockTransfer.barcode') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('stockTransfer.group') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('stockTransfer.product') }}
                  </th>
                  <th class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3">
                    {{ $t('stockTransfer.status') }}
                  </th>
                  <th
                    class="ts-uppercase ts-bg-gray-400 ts-py-1 ts-px-3 text-center"
                    style="width: 9%"
                  >
                    {{ $t('stockTransfer.serial') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(serial, index) in serial_escap_item.serial_no"
                  :key="index"
                >
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.barcode }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.pro_group_name_en }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    {{ data.product.product_name_en }}
                  </td>
                  <td class="ts-py-1 ts-px-3 ts-whitespace-no-wrap">
                    <span
                      :class="'text-' + serialStatusStyle(serial.sn_status_id)"
                      >{{
                        serial.serial_status
                          ? serial.serial_status.sn_status
                          : ''
                      }}</span
                    >
                  </td>
                  <td class="ts-py-1 ts-px-3 text-center ts-whitespace-no-wrap">
                    {{ serial.serial_no }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import Vue from 'vue'
import VueBarcodeScanner from 'vue-barcode-scanner'
let options = {
  sound: false, // default is false
  soundSrc: '', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: null, // default is null
  callbackAfterTimeout: true // default is false
}
Vue.use(VueBarcodeScanner, options)
import { mapState, mapGetters, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import SearchBox from './components/search-box'
import SearchBoxSerial from './components/search-box-serial'
import Manual from './components/manual-add.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'stock-transfer-create',
  components: {
    SearchBox,
    Manual,
    SearchBoxSerial
  },
  data () {
    return {
      show_manual_add: false,
      radioStyle: {
        display: 'block',
        height: '25px',
        lineHeight: '30px'
      },
      activeTab: 1,
      activeTab1: 1,
      from_serial: '',
      to_serial: '',
      to_location: '',
      chk_current_branch: true,
      errors: new Errors(),
      ready_fetch: false,
      fetchFromWarehouse: false,
      fetchToWarehouse: false,
      saving: false,
      savePreviewing: false,
      show_pdf: false,
      show_serial: false,
      src: '',
      product_id: null,
      waiting: false,
      fetchingStockInNumber: false,
      fetchingProduct: false,
      success_message: [],
      info_message: [],
      error_message: [],
      show_detial_item: {},
      products_available: [],
      fetchOptions: {
        search_value: ''
      },
      searchSerial: {
        search_value: ''
      },
      serialForEscap: {
        search_value: ''
      },
      category_id: [],
      product_available_id: [],
      show_escaped_serial: false,
      serial_escap_item: {},
      escaped_serial_no: [],
      fetchEscap: false,
      loading: false,
      model: {
        transfer_date: moment().format('DD-MM-YYYY'),
        from_location_id: '',
        to_location_id: '',
        to_branch_id: '',
        sn_status_id: '',
        sub_item_list: [],
        sub_item_list_by_serial_range: [],
        total_amount: 0
      },
      item: {
        stock_transfer_detail_id: 0,
        product_id: '',
        uom_id: '',
        cost: 0,
        quantity: null,
        available_quantity: null,
        max_serial_no: '',
        min_serial_no: '',
        transfer_quantity: null,
        serial_no: []
      }
    }
  },
  validations: {
    model: {
      sn_status_id: { required }
    }
  },
  computed: {
    ...mapState('stock/transferBySerial', [
      'from_warehouses',
      'to_warehouses',
      'products',
      'uom',
      'branches',
      'serialStatus',
      'categoryAvailable',
      'productAvailable'
    ]),
    ...mapGetters('stock/transferBySerial', [
      'getProdcutById',
      'getUomNameById',
      'totalAmount'
    ]),
    allow_only_scan_on_transfer () {
      return this.$store.state.authUser.user.allow_only_scan_on_transfer
    },
    snStatusIdErrors () {
      const errors = []
      if (!this.$v.model.sn_status_id.$error) return errors
      !this.$v.model.sn_status_id.required &&
        errors.push('Transfer status is required.')
      return errors
    },
    serialResource () {
      if (_.isEmpty(this.show_detial_item)) return []

      if (this.searchSerial.search_value) {
        return _.orderBy(this.show_detial_item.serial_no, [], ['asc']).filter(
          s =>
            s
              .toLowerCase()
              .indexOf(this.searchSerial.search_value.toLowerCase()) != -1
        )
      }
      if (this.from_serial && !this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no => serial_no >= this.from_serial
          ),
          [],
          ['asc']
        )
      }
      if (!this.from_serial && this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no => serial_no <= this.to_serial
          ),
          [],
          ['asc']
        )
      }
      if (this.from_serial && this.to_serial) {
        return _.orderBy(
          _.filter(
            this.show_detial_item.serial_no,
            serial_no =>
              serial_no >= this.from_serial && serial_no <= this.to_serial
          ),
          [],
          ['asc']
        )
      }
      return _.orderBy(this.show_detial_item.serial_no, [], ['asc'])
    },
    fromWarehouses () {
      return _.orderBy(this.from_warehouses, ['location_name_en'])
    },
    toWarehouses () {
      if (this.model.to_branch_id) {
        return _.orderBy(this.to_warehouses, ['location_name_en']).filter(
          w => w.branch_id == this.model.to_branch_id
        )
      }
      return _.orderBy(this.to_warehouses, ['location_name_en']).filter(
        w => w.location_id != this.model.from_location_id
      )
    },
    productAvailables () {
      if (this.category_id.length > 0) {
        return _.orderBy(this.productAvailable, ['product_name']).filter(p =>
          _.includes(this.category_id, p.category_id)
        )
      }
      return _.orderBy(this.productAvailable, ['product_name'])
    },
    categoryAvailables () {
      return _.orderBy(this.categoryAvailable, ['product_name'])
    },
    isEmpty () {
      return _.isEmpty(this.show_detial_item)
    }
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.fetchResourceBeforeCreate()
    if (this.allow_only_scan_on_transfer) {
      this.$barcodeScanner.init(this.onBarcodeScanned)
      this.activeTab = 2
    }
  },
  destroyed () {
    // Remove listener when component is destroyed
    if (this.allow_only_scan_on_transfer) {
      this.$barcodeScanner.destroy()
    }
  },
  methods: {
    ...mapActions('stock/transferBySerial', [
      'getCategoryAvailable',
      'getProductAvailable'
    ]),
    // Create callback function to receive barcode when the scanner is already done
    onBarcodeScanned (scanVaule) {
      if (this.allow_only_scan_on_transfer) {
        this.fetchOptions.search_value = scanVaule
        this.fetchProduct()
      }
      // do something...
    },
    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode () {
      if (this.allow_only_scan_on_transfer) {
        let barcode = this.$barcodeScanner.getPreviousCode()
      }
      // do something...
    },
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('stock/transferBySerial/dataBeforeCreate')
        .then(() => {
          this.onChangeBranch()
          this.getFromWarehouse()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.ready_fetch = false
        })
    },
    setCurrentBranch () {
      this.model.from_location_id = this.model.to_location_id = this.model.to_branch_id =
        ''
      this.onChangeBranch()
      if (this.chk_current_branch) {
        this.getFromWarehouse()
      }
    },
    onChangeBranch () {
      this.fetchToWarehouse = true
      this.model.to_location_id = ''
      this.$store
        .dispatch('stock/transferBySerial/getToWarehouses', {
          to_branch_id: this.model.to_branch_id
        })
        .finally(() => {
          this.fetchToWarehouse = false
        })
    },
    getFromWarehouse () {
      this.fetchFromWarehouse = true
      this.model.from_location_id = ''
      this.$store
        .dispatch('stock/transferBySerial/getFromWarehouses')
        .finally(() => {
          this.fetchFromWarehouse = false
          this.model.from_location_id = this.fromWarehouses
            .filter(w => w.is_default == true)
            .reduce((init, value) => (init = value), null).location_id
        })
    },
    fetchProduct () {
      this.fetchingProduct = true
      this.$store
        .dispatch('stock/transferBySerial/getProductSearch', {
          search_value: this.fetchOptions.search_value,
          from_location_id: this.model.from_location_id
        })
        .then(response => {
          if (response.length) {
            this.scanBarcode(response[0])
          } else {
            this.onClickProduct(response)
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchingProduct = false
        })
    },
    fetchProductAvailable () {
      this.fetchingProduct = true
      this.$store
        .dispatch(
          'stock/transferBySerial/getProductAvailableSearch',
          Object.assign(
            {},
            {
              category_id: this.category_id,
              from_location_id: this.model.from_location_id,
              product_id: this.product_available_id
            }
          )
        )
        .then(response => {
          this.products_available = response
          this.addToList()
        })
        .finally(() => {
          this.fetchingProduct = false
        })
    },
    addToList (e) {
      this.products_available.map(el => {
        let checkItem = this.model.sub_item_list_by_serial_range
          .filter(s => s.product_id == el.product_id && s.uom_id == el.uom_id)
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkItem)) {
          // move product to first index
          this.model.sub_item_list_by_serial_range.sort(function (x, y) {
            return x == checkItem ? -1 : y == checkItem ? 1 : 0
          })
        } else {
          this.item = {
            stock_transfer_detail_id: 0,
            product_id: el.product_id,
            uom_id: el.uom_id,
            cost: 0,
            available_quantity: el.available_quantity,
            max_serial_no: el.max_serial_no,
            min_serial_no: el.min_serial_no,
            transfer_quantity: el.available_quantity,
            serial_no: []
          }
          this.$forceUpdate()
          this.model.sub_item_list_by_serial_range.unshift(_.clone(this.item))
        }
      })
    },
    fetchSerialForEscap () {
      this.fetchEscap = true
      this.$store
        .dispatch(
          'stock/transferBySerial/getProductSearch',
          this.serialForEscap
        )
        .then(response => {
          this.onClickEscap(response.data[0])
        })
        .finally(() => {
          this.fetchEscap = false
        })
    },
    onClickEscap (product) {
      if (product) {
        if (
          this.serial_escap_item.product_id == product.product_id &&
          this.serial_escap_item.uom_id == product.uom_id
        ) {
          let serialExist = this.escaped_serial_no.filter(
            serial_no => serial_no == product.serial_no
          )
          if (serialExist.length <= 0) {
            this.escaped_serial_no.push(product.serial_no)
          } else {
            this.$toasted.info('This serial number already exist.')
          }
        }
      }
    },
    submit () {
      this.success_message = []
      this.info_message = []
      this.error_message = []
      if (this.show_detial_item) {
        let checkItem = this.model.sub_item_list
          .filter(
            s =>
              s.product_id == this.show_detial_item.product_id &&
              s.uom_id == this.show_detial_item.uom_id
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkItem)) {
          let excludeSerials = _.difference(
            checkItem.serial_no,
            this.serialResource
          )
          if (excludeSerials.length > 0) {
            let newSerial = this.serialResource
            checkItem.serial_no = []
            newSerial.map(serial => checkItem.serial_no.unshift(serial))
            checkItem.quantity = checkItem.serial_no.length
            this.from_serial = ''
            this.to_serial = ''
            this.searchSerial.search_value = ''
            this.show_serial = false
            this.$refs.info.localShow = true
            this.info_message.push(
              'Selected ' +
                newSerial.length +
                ' serial numbers were added to product: ' +
                this.getProdcutById(this.show_detial_item.product_id)
                  .product_name_en +
                '; Others were removed.'
            )
          } else {
            this.from_serial = ''
            this.to_serial = ''
            this.searchSerial.search_value = ''
            this.show_serial = false
          }
        }

        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
      }
    },
    onClickProduct (product) {
      this.success_message = []
      this.info_message = []
      this.error_message = []
      if (product) {
        this.product_id = product.product_id
        let p = this.products
          .filter(p => p.product_id == product.product_id)
          .reduce((init, value) => (init = value), null)
        if (!p) {
          this.product_id = null
          this.$toasted.info(
            'Product not found! Please verify serial number or barcode.'
          )
          return
        }
        this.item = {
          stock_transfer_detail_id: 0,
          product_id: p.product_id,
          uom_id: product.uom_id,
          quantity: 1,
          available_quantity: product.ending_balance,
          cost: 0,
          serial_no: []
        }
        let checkItem = this.model.sub_item_list
          .filter(
            s =>
              s.product_id == this.item.product_id &&
              s.uom_id == this.item.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkItem)) {
          let serialExist = checkItem.serial_no.filter(
            serial_no => serial_no == product.serial_no
          )
          if (serialExist.length <= 0) {
            checkItem.serial_no.push(product.serial_no)
            checkItem.quantity = checkItem.serial_no.length
          } else {
            this.$toasted.info('This serial number already exist.')
          }
          // move product to first index
          this.model.sub_item_list.sort(function (x, y) {
            return x == checkItem ? -1 : y == checkItem ? 1 : 0
          })
          this.$forceUpdate()
        } else {
          this.item.serial_no.unshift(product.serial_no)
          this.$forceUpdate()
          this.model.sub_item_list.unshift(_.clone(this.item))
        }
        this.fetchOptions.search_value = ''
      } else {
        let product = this.products
          .filter(p => p.barcode == this.fetchOptions.search_value)
          .reduce((init, value) => (init = value), null)
        if (!product) {
          this.product_id = null
          this.$toasted.info(
            'Product not found! Please verify serial number or barcode.'
          )
          return
        }
        this.product_id = product.product_id
        let checkItem = this.model.sub_item_list
          .filter(
            p =>
              p.product_id == product.product_id || p.uom_id == product.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (_.isEmpty(checkItem)) {
          this.model.sub_item_list.unshift({
            stock_transfer_detail_id: 0,
            product_id: product.product_id,
            uom_id: product.uom_category.unit_of_measures
              .filter(u => u.is_default == true)
              .reduce((init, value) => (init = value.uom_id), null),
            quantity: 1,
            cost: 0,
            serial_no: []
          })
        } else {
          checkItem.quantity = checkItem.quantity + 1
        }
        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
        this.fetchOptions.search_value = ''
      }
    },
    scanBarcode (pro) {
      let product = this.products
        .filter(p => p.product_id == pro.product_id)
        .reduce((init, value) => (init = value), null)
      if (!product) {
        this.product_id = null
        this.$toasted.info(
          'Product not found! Please verify serial number or barcode.'
        )
        return
      }
      this.product_id = product.product_id
      let checkItem = this.model.sub_item_list
        .filter(
          p => p.product_id == product.product_id || p.uom_id == product.uom_id
        )
        .reduce((init, value) => (init = value), {})
      if (_.isEmpty(checkItem)) {
        this.model.sub_item_list.unshift({
          stock_transfer_detail_id: 0,
          product_id: product.product_id,
          quantity: pro.ending_balance,
          available_quantity: pro.ending_balance,
          uom_id: product.uom_category.unit_of_measures
            .filter(u => u.is_default == true)
            .reduce((init, value) => (init = value.uom_id), null),
          cost: 0,
          serial_no: []
        })
      } else {
        checkItem.quantity = checkItem.quantity + 1
      }
      // move product to first index
      this.model.sub_item_list.sort(function (x, y) {
        return x == checkItem ? -1 : y == checkItem ? 1 : 0
      })
      this.fetchOptions.search_value = ''
    },
    removeRow (item) {
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(item), 1)
    },
    removeSerialRangeRow (item) {
      this.model.sub_item_list_by_serial_range.splice(
        this.model.sub_item_list_by_serial_range.indexOf(item),
        1
      )
    },
    removeSerial (serial) {
      let checkItem = this.model.sub_item_list
        .filter(
          p =>
            p.product_id == this.show_detial_item.product_id &&
            p.uom_id == this.show_detial_item.uom_id
        )
        .reduce((init, value) => (init = value), null)

      if (!_.isEmpty(checkItem)) {
        if (checkItem.serial_no.length == 1) {
          checkItem.serial_no.splice(
            this.show_detial_item.serial_no.indexOf(serial),
            1
          )
          this.model.sub_item_list.splice(
            this.model.sub_item_list.indexOf(checkItem),
            1
          )
        } else {
          checkItem.serial_no.splice(
            this.show_detial_item.serial_no.indexOf(serial),
            1
          )
          checkItem.quantity = checkItem.serial_no.length
        }
        this.product_id = checkItem.product_id
        // move product to first index
        this.model.sub_item_list.sort(function (x, y) {
          return x == checkItem ? -1 : y == checkItem ? 1 : 0
        })
      }
    },
    countSerial (serial) {
      return _.keys(serial).length
    },
    grandTotal () {
      this.model.total_amount = _.ceil(
        _.sumBy(this.model.sub_item_list, detail => this.totalAmount(detail)),
        2
      )
    },
    store () {
      this.$v.$touch()
      if (this.$v.$error) {
        this.saving = false
        return
      }

      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch(
          'stock/transferBySerial/store',
          Object.assign({}, this.model, {
            chk_current_branch: this.chk_current_branch,
            report_template: ''
          })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$router.push({ name: 'transfer-by-serial' })
        })
        .catch(error => {
          this.saving = false
          if (
            error.message === 'To branch not found main warehouse.' ||
            error.message ===
              'Transfer across branch is for user that assign to main warehouse.' ||
            error.message ===
              'The current user not yet belong to any warehouses.'
          ) {
            this.$toasted.info(error.message)
          } else {
            this.$toasted.error(error.message)
          }
          this.errors = new Errors(error.errors)
        })
    },
    storePreview () {
      this.$v.$touch()
      if (this.$v.$error) {
        this.savePreviewing = false
        return
      }

      this.errors = new Errors()
      this.savePreviewing = true
      this.$store
        .dispatch(
          'stock/transferBySerial/store',
          Object.assign({}, this.model, {
            chk_current_branch: this.chk_current_branch,
            report_template: 'transfer-by-serial'
          })
        )
        .then(response => {
          this.show_pdf = true
          this.$toasted.success(response.message)
          this.src = response.url
          this.savePreviewing = false
          this.clearInput()
        })
        .catch(error => {
          this.savePreviewing = false
          if (
            error.message === 'To branch not found main warehouse.' ||
            error.message ===
              'Transfer across branch is for user that assign to main warehouse.' ||
            error.message ===
              'The current user not yet belong to any warehouses.'
          ) {
            this.$toasted.info(error.message)
          } else {
            this.$toasted.error(error.message)
          }
          this.errors = new Errors(error.errors)
        })
    },
    clearInput () {
      this.to_location = ''
      ;(this.chk_current_branch = true),
        (this.model = {
          transfer_date: moment().format('DD-MM-YYYY'),
          from_location_id: '',
          to_location_id: '',
          to_branch_id: '',
          sub_item_list: [],
          sub_item_list_by_serial_range: [],
          total_amount: null
        })
    },
    show (item) {
      this.show_serial = true
      this.show_detial_item = item
    },
    escapedSerial (item) {
      this.show_escaped_serial = true
      this.serial_escap_item = item
    },
    handleCancel (e) {
      this.show_serial = false
    },
    callback (key) {
      this.activeTab = key
      this.model.sub_item_list = []
      this.model.sub_item_list_by_serial_range = []
    },
    callback1 (key) {
      this.from_serial = ''
      this.to_serial = ''
      this.searchSerial.search_value = ''
      this.activeTab1 = key
    },
    manualAdd () {
      this.show_manual_add = true
    },
    select (index) {
      this.$refs.transfer_quantity[index].select()
    },
    onSerialQtyEnter (index) {
      if (index + 1 < this.model.sub_item_list_by_serial_range.length) {
        this.$refs.transfer_quantity[index + 1].focus()
        this.$refs.transfer_quantity[index + 1].select()
      } else {
        this.$refs.transfer_quantity[0].focus()
        this.$refs.transfer_quantity[0].select()
      }
    },
    getSerialByQty (item, index) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.serialByQty(item, index)
      }, 800)
    },
    serialByQty (item, index) {
      if (item.transfer_quantity) {
        this.$store
          .dispatch(
            'stock/transferBySerial/getNewSerialByQty',
            Object.assign(item, {
              from_location_id: this.model.from_location_id
            })
          )
          .then(response => {
            if (item.transfer_quantity > response[0].avialable_quantity) {
              // item.transfer_quantity = response[0].avialable_quantity
            }
            item.min_serial_no = response[0].min_serial_no
            item.max_serial_no = response[0].max_serial_no
          })
          .finally(() => {
            this.fetchEscap = false
          })
      }
    },
    onCountQtyEnter (index) {
      if (index + 1 < this.model.sub_item_list.length) {
        this.$refs.quantity[index + 1].focus()
      } else {
        this.$refs.quantity[0].focus()
      }
    }
  },
  watch: {
    'model.sub_item_list': {
      handler () {
        this.grandTotal()
      },
      deep: true
    },
    'model.from_location_id': function (val) {
      if (val) {
        this.model.sub_item_list_by_serial_range = []
        this.getCategoryAvailable({ from_location_id: val })
        this.getProductAvailable({ from_location_id: val })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/transferBySerial/RESET_STATE')
    this.$store.commit('stock/transferBySerial/SET_TO_WAREHOUSES', [])
    this.$store.commit('stock/transferBySerial/SET_BRANCHES', [])
    next()
  }
}
</script>
<style lang="css" scoped>
#container-product {
  height: 70px;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}
#product-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 9; */
  padding: 7px;
  border-bottom: none !important;
}
.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #e9f1f8;
}

#product-table > tbody > tr > td {
  cursor: pointer;
}
.line {
  border: 0;
  background-color: rgb(131, 129, 129);
  height: 2px;
  cursor: pointer;
}
.w-fit {
  width: fit-content;
}
.max-h {
  max-height: 300px;
  overflow: scroll;
}
.alert {
  margin-bottom: 2px !important;
}
.ts-list-disc {
  margin-left: 20px;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 0rem;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  text-align: center;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 12px;
  line-height: 1.42857143;
  height: 25px;
  padding: 2px 4px;
}
.ts-h-64 {
  height: 20rem;
}
</style>
